<script>
    export let data;
    data = JSON.parse(data);
</script>

<div class="home-readmore-wrapper readmore">
    <div class="home-middle">
        <p class="footer-byline">by {@html data.byline}</p>
        <p class="footer-contrib">{@html data.contributors}</p>
    </div>
</div>

<style lang="scss"></style>
